import React, {useEffect, useState} from "react";
import SearchBar from "../searchbar/SearchBar.component";
import "./NewCurrentOfferings.scss";
import FiltersPanel from "../filterspanel/FiltersPanel.component";
import CurrentOfferingsTable from "../curent-offerings-table/CurrentOfferingsTable.component";
import ActionButtons from "../action-buttons/ActionButtons";
import TranslateComponent from "../../misc/translate/Translate.component";
import {WEEKLY_OFFEERINGS_TITLE_LABEL_KEY} from "../../../constants/CurrentOfferings.constants";
import {FetchOfferings} from "../../../services/NewCurrentOfferings.service";
import SpinnerComponent from "../../spinner/Spinner.component";
import {ADVANCED_FILTERS, HIDE_FILTERS} from "../constants/NewCurrentOfferings";
import LanguageService from "../../../services/Language.service";
import {CURRENT_OFFERINGS_PAGE_TITLE} from "../../../constants/PageTitle.constants";

export default function NewCurrentOfferings({currentLanguage}) {
  const [searchQuery, setSearchQuery] = useState("");
  const [orderBy, setOrderBy] = useState("");
  const [sortingColumn, setSortingColumn] = useState("");
  const [descending, setDescending] = useState(false);
  const [error, setError] = useState("");
  const [filters, setFilters] = useState({});
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showFiltersPanel, setShowFiltersPanel] = useState(false);
  const [isSimpleSearch, setIsSimpleSearch] = useState(true);

  const handleSearch = async (query) => {
    setIsSimpleSearch(true);
    setSearchQuery(() => query);
  };

  const handleFilterSearch = (filterValues) => {
    setIsSimpleSearch(false);
    setFilters(() => filterValues);
  };
  const toggleFilters = () => {
    setShowFiltersPanel((prev) => !prev);
  };

  const handleSort = (field) => {
    setSortingColumn(() => field);
    setOrderBy(() => field);
    setDescending((prev) => (orderBy === field ? !prev : false));
  };

  useEffect(() => {
    document.title = LanguageService.translate(CURRENT_OFFERINGS_PAGE_TITLE);
  }, []);

  useEffect(() => {
    setLoading(() => true);
    FetchOfferings({
      search: isSimpleSearch ? searchQuery : "",
      filters: ! isSimpleSearch ? filters : {},
      orderBy,
      descending,
      language: currentLanguage,
    })
      .then((response) => {
        setData(response);
        setLoading(() => false);
        setSortingColumn(() => "");
      })
      .catch((err) => {
        setError("An error occurred while fetching");
        setLoading(() => false);
        setSortingColumn(() => "");
      });
  }, [isSimpleSearch, filters, orderBy, searchQuery, descending, currentLanguage]);

  return (
    <section className="tds-current-offering">
      <div className="tds-container">
        <div className="tds-current-offerings-title non-printable">
          <h1>
            <TranslateComponent label={WEEKLY_OFFEERINGS_TITLE_LABEL_KEY} />
          </h1>
        </div>
        <div className="current-offerings">
          <div className="non-printable">
            <div className="search-bar-container">
              <SearchBar onSearch={handleSearch} />
              <button
                className="btn btn-block td-btn-secondary-clear sn-offerings-advanced-search-btn advanced-filters"
                onClick={toggleFilters}
                data-testid={"toggleFilter"}
              >
                <TranslateComponent
                  label={showFiltersPanel ? HIDE_FILTERS : ADVANCED_FILTERS}
                />
              </button>
            </div>
            {showFiltersPanel && (
                <FiltersPanel
                    onFilterSearch={handleFilterSearch}
                    disableFilters={false}
                />
            )}
            <ActionButtons
              fetchParams={{
                search: searchQuery,
                filters,
                orderBy,
                descending,
                language: currentLanguage,
              }}
            />
          </div>

          {loading && !sortingColumn && (
            <SpinnerComponent
              marginTop={100}
              minHeight={1200}
              marginLeft={10}
            />
          )}
          {!error && data && (
            <CurrentOfferingsTable
              data={data}
              onSort={handleSort}
              sortingColumn={sortingColumn}
              currentLanguage={currentLanguage}
            />
          )}
          {error && <div className="errormessage">{error}</div>}
        </div>
      </div>
    </section>
  );
}
